// import Script from 'next/script';
import React from 'react';
import { isTestnet, isProd } from '@bfe/by-env';


export const GetCompliance: React.FC = () => {

  const NODE_ENV = process.env.NODE_ENV;
  let url = '';
  if (isProd) {
    url = '/common-static/fhs/compliance-upload/low-cache/compliance-sdk/spot-fe-spotx.js';
  } else if (isTestnet) {
    url = '/common-static/fhs/compliance-upload/low-cache/compliance-sdk/testnet/spot-fe-spotx.js';
  } else {
    url = 'https://www.unify-test-3.bybit.com/common-static/fhs/compliance-upload/low-cache/compliance-sdk/test/spot-fe-spotx.js';
  }

  return (
    <script data-index="0.9" crossOrigin="anonymous" src={url} />
  );
};
